import { uniqBy } from 'lodash';
import * as types from './types';

export const initialState = {
  isFetching: false,
  error: false,
  errorMessage: '',
  credentialsList: [],
  credentialsSelected: [],
  createEdit: {
    id: 0,
    username: '',
    password: '',
    leakDate: null,
    owned: false,
    linkedVulns: []
  },
  showCreateEditModal: false,
  showDetail: false,
  showContextMenu: false,
  contextMenuXPos: 0,
  contextMenuYPos: 0,
  showImport: false,
  currentUploadState: '',
  currentUploadPercent: 0,
  currentUploadError: '',
  errorFilesList: [],
  filesToUpload: [],
  fileIndex: -1,
  uploadState: '',
  availableVulns: [],
  showDeleteConfirmation: false,
  credentialToDelete: 0,
  count: 0,
  credentialDetail: undefined,
  isFetchingVulns: false,
  fetchingCredential: false
};

function credentials (state = initialState, action) {
  switch (action.type) {
    case types.CREDENTIALS_FETCHING: {
      return {
        ...state,
        isFetching: true
      };
    }

    case types.SET_ERROR_CREATE_CREDENTIAL: {
      return {
        ...state,
        errorCreateCredential: action.error
      };
    }

    case types.SET_CREDENTIAL_FIELD: {
      return {
        ...state,
        createEdit: {
          ...state.createEdit,
          value: {
            ...state.createEdit.value,
            [action.field]: action.value
          }
        }
      };
    }

    case types.SAVE_CREDENTIAL_FAIL: {
      return {
        ...state,
        isFetching: false,
        error: true,
        errorMessage: action.errorMessage
      };
    }

    case types.SAVE_CREDENTIAL_SUCCESS: {
      const { credentialsList } = state;
      let newList = [];

      if (action.id) {
        const index = credentialsList.findIndex((c) => c._id === c.id);
        newList = [...credentialsList];
        newList[index] = action.response;
      } else newList = [...credentialsList, action.response];

      return {
        ...state,
        credentialsList: [...newList],
        credentialsSelected: [],
        isFetching: false
      };
    }

    case types.SHOW_CREATE_EDIT_MODAL: {
      return {
        ...state,
        showCreateEditModal: action.show,
        createEdit: action.credential || state.createEdit
      };
    }

    case types.SHOW_CREDENTIAL_DETAIL: {
      return {
        ...state,
        showDetail: action.show,
        credentialDetail: action.detail,
        fetchingCredential: false
      };
    }

    case types.CREDENTIAL_UPDATE_SUCCESS: {
      return {
        ...state,
        credentialsSelected: action.isVulnDetail || state.credentialsSelected.length === 0 ? [] : [action.credentialAfter],
        credentialsList: action.credentialsList,
        credentialDetail: action.credentialAfter
      };
    }

    case types.CREDENTIAL_UPDATE_FAIL: {
      return {
        ...state,
        error: true,
        errorMessage: action.error
      };
    }

    case types.SHOW_CONTEXT_MENU: {
      return {
        ...state,
        showContextMenu: action.show,
        contextMenuXPos: action.contextMenuXPos,
        contextMenuYPos: action.contextMenuYPos
      };
    }

    case types.SHOW_CREDENTIAL_IMPORT: {
      return {
        ...state,
        showImport: action.show
      };
    }

    case types.CREDENTIALS_SET_CSV_FILE_INDEX: {
      return {
        ...state,
        fileIndex: action.index
      };
    }

    case types.CREDENTIALS_SET_FILES_TO_UPLOAD: {
      return {
        ...state,
        filesToUpload: action.files
      };
    }

    case types.CREDENTIALS_SET_UPLOAD_STATE: {
      return {
        ...state,
        uploadState: action.state
      };
    }

    case types.CREDENTIALS_UPLOAD_CSV_UPDATE_PERCENT: {
      return {
        ...state,
        currentUploadState: 'Uploading',
        currentUploadPercent: Math.round(
          (100 * action.progressEvent.loaded) / action.progressEvent.total
        ),
        currentUploadError: ''
      };
    }

    case types.CREDENTIALS_UPLOAD_CSV_ERROR: {
      return {
        ...state,
        currentUploadState: 'Error',
        currentUploadPercent: 0,
        currentUploadError: action.error
      };
    }

    case types.CREDENTIALS_CANCEL_REQUEST_UPLOAD_CSV: {
      return {
        ...state,
        currentUploadState: 'Canceled',
        currentUploadPercent: 0,
        currentUploadError: ''
      };
    }

    case types.CREDENTIALS_SET_NAME_INTO_FILE_ERROR_LIST_CSV: {
      return {
        ...state,
        errorFilesList: [...state.errorFilesList, action.name]
      };
    }

    case types.CREDENTIALS_RESET_FILE_STATE: {
      return {
        ...state,
        currentUploadState: '',
        currentUploadPercent: 0,
        currentUploadError: '',
        errorFilesList: [],
        filesToUpload: [],
        fileIndex: -1,
        uploadState: ''
      };
    }

    case types.CREDENTIALS_EXPORT_CSV_REQUEST: {
      return {
        ...state,
        isExportingCSV: true
      };
    }

    case types.CREDENTIALS_EXPORT_CSV_SUCCESS: {
      return {
        ...state,
        isExportingCSV: false
      };
    }

    case types.CREDENTIALS_EXPORT_CSV_FAILURE: {
      return {
        ...state,
        error: true,
        errorMessage: 'There was an error, please try again.',
        isExportingCSV: false
      };
    }

    case types.CREDENTIALS_CLEAR_ERROR: {
      return {
        ...state,
        error: false,
        errorMessage: ''
      };
    }

    case types.CREDENTIALS_GET_SUCCESS: {
      return {
        ...state,
        credentialsList: action.credentials,
        isFetching: false,
        count: action.count
      };
    }

    case types.CREDENTIALS_GET_FAIL: {
      return {
        ...state,
        isFetching: false,
        error: true,
        errorMessage: action.errorMessage,
        isFetchingVulns: false
      };
    }

    case types.INDIVIDUAL_SELECTION_CREDENTIALS: {
      return {
        ...state,
        credentialsSelected: [action.credential]
      };
    }

    case types.MULTIPLE_SELECTION_CREDENTIALS: {
      return {
        ...state,
        credentialsSelected: uniqBy(
          [...state.credentialsSelected, action.credential],
          'id'
        )
      };
    }

    case types.CREDENTIALS_UNSELECTED: {
      return {
        ...state,
        credentialsSelected: state.credentialsSelected.filter(
          (e) => e.id !== action.credential.id
        )
      };
    }

    case types.SET_AVAILABLE_VULNS: {
      return {
        ...state,
        availableVulns: action.availableVulns,
        isFetchingVulns: false
      };
    }

    case types.CREDENTIALS_SET_BULK_UPDATE_FIELD: {
      return {
        ...state,
        bulkUpdateField: action.field,
        bulkUpdateValue: ''
      };
    }

    case types.CREDENTIALS_SET_BULK_UPDATE_VALUE: {
      return {
        ...state,
        bulkUpdateValue: action.value
      };
    }

    case types.CREDENTIALS_ADD_BULK_UPDATE_VALUE: {
      const bulkUpdateValue = state.bulkUpdateValue;
      bulkUpdateValue.push(action.value);

      return {
        ...state,
        bulkUpdateValue
      };
    }

    case types.CREDENTIALS_REMOVE_BULK_UPDATE_VALUE: {
      let bulkUpdateValue = state.bulkUpdateValue;
      bulkUpdateValue = bulkUpdateValue.filter((element) => element !== action.value);

      return {
        ...state,
        bulkUpdateValue
      };
    }

    case types.CREDENTIALS_REFRESH_LIST: {
      return {
        ...state,
        credentialsList: action.credentialsList,
        credentialsSelected: action.credentialsSelected
      };
    }

    case types.CREDENTIALS_SET_BULK_UPDATE_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        error: false,
        errorMessage: ''
      };
    }

    case types.CREDENTIALS_BULK_UPDATE_FINISHED: {
      return {
        ...state,
        isFetching: false,
        bulkUpdateField: '',
        bulkUpdateValue: ''
      };
    }

    case types.CREDENTIALS_ERROR: {
      return {
        ...state,
        error: true,
        errorMessage: action.error,
        fetchingCredential: false
      };
    }

    case types.CREDENTIALS_UNSELECT_ALL: {
      return {
        ...state,
        credentialsSelected: []
      };
    }

    case types.CREDENTIALS_SHOW_DELETE_CONFIRMATION: {
      return {
        ...state,
        showDeleteConfirmation: action.show,
        credentialToDelete: action.id
      };
    }

    case types.SET_AVAILABLE_VULNS_FETCHING: {
      return {
        ...state,
        isFetchingVulns: true
      };
    }

    case types.CREDENTIALS_SELECT_ALL: {
      return {
        ...state,
        credentialsSelected: action.credentialsList
      };
    }

    case types.FETCHING_CREDENTIAL: {
      return {
        ...state,
        fetchingCredential: true
      };
    }

    default: {
      return state;
    }
  }
}

export default credentials;
